import './mui.scss';

import * as React from 'react';
import { useState } from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

function MuiUnstyledTimePicker() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <div className={`dupa`}>

    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        open={open}
        onClose={handleClose}
        value={value}
        onChange={handleChange}
        format={'HH:mm'}
        ampm={false}
        minutesStep={15}

        slotProps={{
          textField: {
            onClick: handleOpen,
          },
        }}
        // You can optionally hide the default clock icon
        // slots={{ openPickerIcon: () => null }}
      />
    </LocalizationProvider>
    </div>
  );
}

export default MuiUnstyledTimePicker;